import { EntityFields } from './entity';
import {
  FieldOptionsResponse,
  FieldOptionsWithData,
} from './field-options';
import { KeyAndDisplay } from './key-and-display';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';
import { ValueAndDisplay } from './value-and-display';

export enum WorkflowTaskTemplateFields {
  Key = EntityFields.Key,
  Subject = 'Subject',
  WorkflowKey = 'WorkflowKey',
  Sequence = 'Sequence',
  DateOffsetUnit = 'DateOffsetUnit',
  DateOffsetValue = 'DateOffsetValue',
  Time = 'Time',
  AlarmOffsetUnit = 'AlarmOffsetUnit',
  AlarmOffsetValue = 'AlarmOffsetValue',
  Priority = 'Priority',
  IconType = 'IconType',
  Category = 'Category',
  AssignedToExpression = 'AssignedToExpression',
}

export interface WorkflowTaskTemplate {
  [WorkflowTaskTemplateFields.Key]: string | null;
  [WorkflowTaskTemplateFields.Subject]?: string;
  [WorkflowTaskTemplateFields.WorkflowKey]?: string;
  [WorkflowTaskTemplateFields.Sequence]?: number;
  [WorkflowTaskTemplateFields.DateOffsetUnit]?: number;
  [WorkflowTaskTemplateFields.DateOffsetValue]?: number;
  [WorkflowTaskTemplateFields.Time]?: string;
  [WorkflowTaskTemplateFields.AlarmOffsetUnit]?: number;
  [WorkflowTaskTemplateFields.AlarmOffsetValue]?: number;
  [WorkflowTaskTemplateFields.Priority]?: ValueAndDisplay<string>;
  [WorkflowTaskTemplateFields.IconType]?: ValueAndDisplay<number>;
  [WorkflowTaskTemplateFields.Category]?: ValueAndDisplay<string>;
  [WorkflowTaskTemplateFields.AssignedToExpression]?: ValueAndDisplay<string>;
}

export interface WorkflowTaskTemplateFieldOptions {
  [WorkflowTaskTemplateFields.Category]: KeyAndDisplay;
  [WorkflowTaskTemplateFields.Priority]: KeyAndDisplay;
  [WorkflowTaskTemplateFields.AssignedToExpression]: KeyAndDisplay;
  [WorkflowTaskTemplateFields.DateOffsetUnit]: KeyAndDisplay;
  [WorkflowTaskTemplateFields.AlarmOffsetUnit]: KeyAndDisplay;
}

export const WorkflowTaskTemplateFieldsEditableListFields = {
  [WorkflowTaskTemplateFields.Priority]: 60015,
};

export interface WorkflowTaskTemplateReadRequest extends Request {
  WorkflowTaskTemplate: ReadRequest<WorkflowTaskTemplate>;
}

export interface WorkflowTaskTemplateReadResponse extends Response {
  WorkflowTaskTemplate: DataResponse<WorkflowTaskTemplate>;
}

export interface WorkflowTaskTemplateFieldOptionsRequest extends Request {
  WorkflowTaskTemplate: FieldOptionsWithData<
    WorkflowTaskTemplateFieldOptions,
    { EntityType: number }
  >;
}

export interface WorkflowTaskTemplateFieldOptionsResponse extends Response {
  WorkflowTaskTemplate: FieldOptionsResponse<WorkflowTaskTemplateFieldOptions>;
}

export interface WorkflowTaskTemplateWriteRequest extends Request {
  WorkflowTaskTemplate: WriteRequest<WorkflowTaskTemplate>;
}

export interface WorkflowTaskTemplateWriteResponse extends Response {
  WorkflowTaskTemplate: WriteResponse<WorkflowTaskTemplate>;
}
